// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","row":"Footer_row__-1bMG","image_wrapper":"Footer_image_wrapper__j8a+Z","social":"Footer_social__vUYCe"};